import FnAntModal from '../../components/blocks/FnAntModal/index';
import { FnAntModalWidth } from '../../components/blocks/FnAntModal/constants';
import React, { FC } from 'react';
import { Form, Input } from 'antd';
import { DivWrapper } from './styles';
import { faCopy } from '@fortawesome/pro-light-svg-icons';
import { FnButtonTypes, FnButtonVariants } from '../../components/elements/FnButton/constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FnButton from '../../components/elements/FnButton';
import { copyTextToClipboard } from '../../util/copy-text-to-clipboard';

const { TextArea } = Input;

type TProps = {
  productionStatusMessage: string;
  onClose: () => void;
};

export const OrderProductionStatusErrorModal: FC<TProps> = ({
  productionStatusMessage,
  onClose
}) => {
  const copyToClipboard = () => {
    copyTextToClipboard(productionStatusMessage, 'Error copied to clipboard');
  };
  
  return (
    <FnAntModal
      className="order-production-status-error-modal"
      titleText="Order submission can not be performed"
      width={FnAntModalWidth.Lg}
      titleErrorIcon={true}
      isOpen={true}
      onClose={onClose}
    >
      <DivWrapper>
        <Form.Item>
          <TextArea
            value={productionStatusMessage}
            name="productionStatusMessage"
            readOnly={true}
            autoSize={true}
            className="order-production-status-error-modal__textarea"
          />
        </Form.Item>
  
        <FnButton
          className="order-production-status-error-modal__copy-btn"
          variant={FnButtonVariants.Secondary}
          viewType={FnButtonTypes.Text}
          startIcon={<FontAwesomeIcon icon={faCopy}/>}
          text="Copy text"
          onClick={copyToClipboard}
        />
      </DivWrapper>
    </FnAntModal>
  );
};
